/*
 Note:
 This component is included directly into the sources of this project to simplify the
 build process.

 License:
 Copyright 2019, Indoqa Software Design und Beratung GmbH

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import * as React from 'react'
import {TreeFolder} from './TreeFolder'
import {TreeLeaf} from './TreeLeaf'
import {TreeViewContextValue} from './treeView.types'
import {TreeViewContext} from './TreeViewContext'

interface Props<S> {
  structure: S
  level: number
  first: boolean
  last: boolean
}

export function TreeNode<S>(props: Props<S>) {
  const {structure, level, first, last} = props
  const {structureAccessors} = React.useContext<TreeViewContextValue<S>>(TreeViewContext)
  return (
    <>
      {structureAccessors.isLeaf(structure) ? (
        <TreeLeaf<S> structure={structure} level={level} first={first} last={last} />
      ) : (
        <TreeFolder<S> structure={structure} level={level} first={first} last={last} />
      )}
    </>
  )
}
